import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';

export type PartnerWorkerTab = 'clients' | 'builds' | 'profits' | 'landings' | 'templates' | 'sender';

const TABS: { id: PartnerWorkerTab; label: string }[] = [
	{ id: 'clients', label: 'Клиенты' },
	{ id: 'builds', label: 'Билды' },
	{ id: 'profits', label: 'Профиты' },
	{ id: 'landings', label: 'Лендинги' },
	{ id: 'templates', label: 'Шаблоны' },
	{ id: 'sender', label: 'Sender' },
];

interface WorkerTabsProps {
	activeTab: PartnerWorkerTab;
	onTabChange: (tab: PartnerWorkerTab) => void;
}

export default function WorkerTabs({ activeTab, onTabChange }: WorkerTabsProps) {
	return (
		<div className='flex gap-1.5 overflow-x-auto pb-1'>
			<ButtonGroup className='shrink-0'>
				{TABS.map(tab => (
					<Button
						key={tab.id}
						size='sm'
						variant={activeTab === tab.id ? 'secondary' : 'outline'}
						onClick={() => onTabChange(tab.id)}
					>
						{tab.label}
					</Button>
				))}
			</ButtonGroup>
		</div>
	);
}
